<template>
  <div id="app">
    <router-view></router-view>
    <!-- <div>{{$store.state.token}}

    <button @click="click">123</button>
    
  </div> -->
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
// import axios from 'axios';
import { mapActions } from "vuex";
// import  graphql from './utils/graphql'
export default {
  name: "app",
  data() {
    return {
      isShow: true
    };
  },
  components: {
    HelloWorld
  },
  methods: {
    openIndex() {
      this.isShow = false;
      localStorage.setItem("token", "xxx");
      this.$router.replace("/index");
    },
    openView() {
      // if (localStorage.getItem("token")) {
      // this.$router.replace("/home");
      this.isShow = false;
      // }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    this.isShow = true;
    // setTimeout(() => {
    //   this.isShow = false;
    // }, 4000);
    if (this.isMobile()) {
      document.querySelector("body").setAttribute("style", "height:1500px");
      document.querySelector("html").setAttribute("style", "height:1500px");
    } else {
      // alert("pc端");
    }
  }
};
</script>

<style>
/* .el-menu--popup-bottom-start {
  position: fixed;
  top: 10% !important;
} */
@font-face {
  font-family: PingFang;
  src: url("../static/font/pingfang.ttf");
}
.flexRow {
  display: flex;
  align-items: center;
}
.beta2 {
  position: fixed;
  right: 6%;
  top: 6%;
  font-size: 14px;
  font-weight: 900;
  padding: 10px;
  cursor: pointer;
}
.beta {
  font-size: 14px;
  font-weight: 900;
  background: #fff;
  padding: 10px;
  cursor: pointer;
  margin-right: 20px;
}
.modal-desc {
  font-size: 22px;
  margin-top: 4px;
}
.modal-title {
  font-size: 36px;
  margin-top: 40vh;
}
.showModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: #dee3ec;
  top: 0;
  z-index: 999999;
  text-align: center;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-family: PingFang;
}
* {
  margin: 0;
  padding: 0;
}
body,
html {
  min-width: 1400px;
  /* overflow: scroll; */
  height: 100%;
}
.el-tooltip__popper {
  width: 80%;
}
.el-select-dropdown__item.selected {
  color: #29bccf !important;
}
.el-loading-spinner i {
  color: #29bccf !important;
}
.el-loading-spinner .el-loading-text {
  color: #29bccf !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue